import { defineStore } from 'pinia';
import type { Offergroup, CountryUtil } from '@fibl/oxs-common';
import type { EAV } from '@fibl/zdb-common';
import * as SearchRepo from '@/repository/search';

type Ent = EAV.Entity<Offergroup.Offergroup>;

export const useOfferGroupStore = defineStore('offerGroup', {
	state: () => ({
		loading: {} as Record<string, Promise<Ent[]>>,
		loaded: [] as Ent[],
	}),

	getters: {
		getForOfferForm() {
			return (species: string, mat: string, country: CountryUtil.CountryCode): Ent[] => {
				return this.loaded.filter(
					(e) => (!e.data.matType?.length ||e.data.matType.includes(mat))
						&& e.data.country === country
						&& e.data.species === species
				);
			};
		},
	},

	actions: {
		updateGroup(ent: Ent) {
			let existing = this.loaded.findIndex(e => e.id === ent.id);
			if (existing > -1) {
				this.loaded.splice(existing, 1, ent);
			} else {
				this.loaded.push(ent);
			}
		},
		loadForSpecies(species: string, country?: string) {
			const key = `${species}_${country || 'all'}`;
			if (!(key in this.loading)) {
				let p = this._loadForSpecies(species, country);
				this.loading[key] = p;
			}
			return this.loading[key];
		},
		async _loadForSpecies(species: string, country?: string) {
			const filter: SearchRepo.SearchFilter = { $and: [] };
			filter.$and.push({
				field: '/data/species',
				comparison: 'eq',
				value: species,
			});
			if (country) {
				filter.$and.push({
					field: '/data/country',
					comparison: 'eq',
					value: country,
				});
			}
			const res: Ent[] = await SearchRepo.findAll('offergroup', filter, true);
			const idx = new Set(this.loaded.map((e) => e.id));
			this.loaded = this.loaded.concat(res.filter((e) =>!idx.has(e.id)));
			return res;
		},

	},
});
